import {adminApi} from 'sources/api';
import formatSecondsShort from 'utils/formatSecondsShort';
import {AutocompleteResults} from '@components/auto-complete/SingleAutocomplete';

export interface Timezone {
  id: string;
  label: string;
  abbreviation: string;
  name: string;
  country: string;
  countryCode: string;
  offsetInSeconds: number;
  offset: string;
}

function mapResults(r: Timezone[]): Timezone[] {
  return r.sort((a, b) => a.offsetInSeconds - b.offsetInSeconds).map(mapResult);
}

function mapResult(t): Timezone {
  const friendlyOffset = formatSecondsShort(t.offsetInSeconds, true, false, false);

  return {
    ...t,
    offset: friendlyOffset,
    label: `(GMT ${friendlyOffset}) ${t.name}`,
    id: t.name,
  };
}

export default class TimezoneSource {
  static fetchTimezones(token: string): Promise<Timezone[]> {
    return adminApi.getJson('/timezones/search', {params: {token}}).then(mapResults);
  }

  static fetchCommon(): Promise<AutocompleteResults<Timezone>> {
    return adminApi.getJson('/timezones/common').then(({total, results}) => ({
      total,
      results: mapResults(results),
    }));
  }

  static fetchNamed(name: string): Promise<Timezone> {
    return adminApi.getJson(`/timezones/named`, {params: {name}}).then(mapResult);
  }
}
